/* Delegated handler works after Shopify theme-editor section reloads too. */
if (!window.aswSportBound) {
  window.aswSportBound = true;
  document.addEventListener('click', function (event) {
    const toggle = event.target.closest('[data-asw-sale-toggle]');
    if (!toggle) return;
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    panel.hidden = !panel.hidden;
    toggle.setAttribute('aria-expanded', String(!panel.hidden));
    if (!panel.hidden) panel.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
  });
}
